import script from "./gas-table-column.vue?vue&type=script&setup=true&lang=ts"
export * from "./gas-table-column.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__